import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faCircleQuestion, faCircleExclamation, faCircleCheck } from '@fortawesome/pro-light-svg-icons'

library.add(
  faCircleQuestion,
  faCircleExclamation,
  faCircleCheck
)

window.addEventListener('DOMContentLoaded', () => {
  dom.i2svg()
  dom.watch()
})
